/* eslint-disable import/no-cycle */
// Utils
import { findObjectFromValue } from './findObjectInValue';
import { getObjectId } from '../../index';
/**
 * Find the object with the given object id in the given object
 *
 * @template T extends object
 * @param {T} values
 * @param {string} objectId
 *
 * @return {Identifiable<object> | undefined}
 */
export var findObjectWithIdInObject = function (values, objectId) {
    if (objectId === getObjectId(values)) {
        return values;
    }
    var match;
    Object.keys(values).some(function (key) {
        var result = findObjectFromValue(values[key], objectId);
        if (result !== undefined) {
            match = result;
            return true;
        }
        return false;
    });
    return match;
};
//# sourceMappingURL=findObjectWithIdInObject.js.map